import React from 'react';
import { Typography } from '@mui/material';

const VideoPreviewJoyrideContent = (props) => {
    return (
        <Typography variant='body2' align='left'>
            See a live preview of the video. 
            The preview closely resembles how the exported video will look, but there may be some minor differences.
            The preview typically plays at a lower resolution than the exported video to maintain high performance for the editor.
            Also, during playback the preview may appear slow or stuttery.
            The exported video won't be affected by this and will have the correct frame rate.
        </Typography>
    );
};

export default VideoPreviewJoyrideContent;
